// removed by extract-text-webpack-plugin
module.exports = {"subTitle":"_360cAdDymbrKFXbqhqdmLj","row":"_1P00wsRABspfDkgM0_hRQA","name":"_2F6FCDgIxJaAN4pRbPrPrT","unit":"_5dVFlKRJBllBJ6ZEPGbbm","ingredientError":"_3xZ7HerNcEDOYljibpWV4K"};


//////////////////
// WEBPACK FOOTER
// ./app/dialogs/Produce/style.scss
// module id = 1054
// module chunks = 0